import { create } from 'zustand';

const STORAGE_KEY = 'shopgnd-admin-impersonation';

export type AdminImpersonationTarget =
  | { kind: 'vendor'; vendorId: string; label: string }
  | { kind: 'pro'; proId: string; label: string };

function loadSession(): AdminImpersonationTarget | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as AdminImpersonationTarget;
    if (parsed?.kind === 'vendor' && parsed.vendorId) return parsed;
    if (parsed?.kind === 'pro' && parsed.proId) return parsed;
    return null;
  } catch {
    return null;
  }
}

function saveSession(session: AdminImpersonationTarget | null) {
  if (session) sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
  else sessionStorage.removeItem(STORAGE_KEY);
}

interface AdminImpersonationState {
  session: AdminImpersonationTarget | null;
  setSession: (session: AdminImpersonationTarget | null) => void;
  clearSession: () => void;
}

export const useAdminImpersonationStore = create<AdminImpersonationState>((set) => ({
  session: loadSession(),
  setSession: (session) => {
    saveSession(session);
    set({ session });
  },
  clearSession: () => {
    saveSession(null);
    set({ session: null });
  },
}));
